var map = {
	"./afaanoromoo": 67976,
	"./afaanoromoo.ts": 67976,
	"./afrique": 61090,
	"./afrique.ts": 61090,
	"./amharic": 54787,
	"./amharic.ts": 54787,
	"./arabic": 95422,
	"./arabic.ts": 95422,
	"./archive": 94852,
	"./archive.ts": 94852,
	"./azeri": 62588,
	"./azeri.ts": 62588,
	"./bengali": 51290,
	"./bengali.ts": 51290,
	"./burmese": 84659,
	"./burmese.ts": 84659,
	"./cymrufyw": 48137,
	"./cymrufyw.ts": 48137,
	"./gahuza": 46103,
	"./gahuza.ts": 46103,
	"./gujarati": 97381,
	"./gujarati.ts": 97381,
	"./hausa": 72483,
	"./hausa.ts": 72483,
	"./hindi": 29381,
	"./hindi.ts": 29381,
	"./igbo": 6222,
	"./igbo.ts": 6222,
	"./indonesia": 92191,
	"./indonesia.ts": 92191,
	"./japanese": 3194,
	"./japanese.ts": 3194,
	"./korean": 35414,
	"./korean.ts": 35414,
	"./kyrgyz": 7897,
	"./kyrgyz.ts": 7897,
	"./marathi": 48322,
	"./marathi.ts": 48322,
	"./mundo": 25368,
	"./mundo.ts": 25368,
	"./naidheachdan": 53460,
	"./naidheachdan.ts": 53460,
	"./nepali": 99142,
	"./nepali.ts": 99142,
	"./news": 83689,
	"./news.ts": 83689,
	"./newsround": 34974,
	"./newsround.ts": 34974,
	"./pashto": 70240,
	"./pashto.ts": 70240,
	"./persian": 49864,
	"./persian.ts": 49864,
	"./pidgin": 11005,
	"./pidgin.ts": 11005,
	"./portuguese": 28036,
	"./portuguese.ts": 28036,
	"./punjabi": 7801,
	"./punjabi.ts": 7801,
	"./russian": 42184,
	"./russian.ts": 42184,
	"./scotland": 12698,
	"./scotland.ts": 12698,
	"./serbian/base": 34045,
	"./serbian/base.ts": 34045,
	"./serbian/cyr": 43347,
	"./serbian/cyr.ts": 43347,
	"./serbian/lat": 18000,
	"./serbian/lat.ts": 18000,
	"./sinhala": 57960,
	"./sinhala.ts": 57960,
	"./somali": 27833,
	"./somali.ts": 27833,
	"./sport": 79426,
	"./sport.ts": 79426,
	"./swahili": 91569,
	"./swahili.ts": 91569,
	"./tamil": 77595,
	"./tamil.ts": 77595,
	"./telugu": 56973,
	"./telugu.ts": 56973,
	"./thai": 90184,
	"./thai.ts": 90184,
	"./tigrinya": 68180,
	"./tigrinya.ts": 68180,
	"./turkce": 72297,
	"./turkce.ts": 72297,
	"./ukchina/base": 76478,
	"./ukchina/base.ts": 76478,
	"./ukchina/simp": 40171,
	"./ukchina/simp.ts": 40171,
	"./ukchina/trad": 75664,
	"./ukchina/trad.ts": 75664,
	"./ukrainian": 83788,
	"./ukrainian.ts": 83788,
	"./urdu": 19632,
	"./urdu.ts": 19632,
	"./uzbek": 91151,
	"./uzbek.ts": 91151,
	"./vietnamese": 41580,
	"./vietnamese.ts": 41580,
	"./yoruba": 54795,
	"./yoruba.ts": 54795,
	"./zhongwen/base": 77964,
	"./zhongwen/base.ts": 77964,
	"./zhongwen/simp": 85223,
	"./zhongwen/simp.ts": 85223,
	"./zhongwen/trad": 68992,
	"./zhongwen/trad.ts": 68992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 22884;
module.exports = webpackContext;